<button disabled={isDisabled} data-heap-button={trackingId} on:click="{event => click(event)}" data-test-button-id={buttonId} class="ne-button">
  <slot></slot>
</button>

<style>
  .ne-button {
    align-self: center;
  }
</style>

<script>
  export let isDisabled = false;
  export let trackingId;
  export let buttonId;
  export let click;
</script>
